import axios from 'axios';
import getHeaderToken from './getHeaderToken';

const updateContractPeriod = async (formData) => {
    try {
      const headers = await getHeaderToken();
      const url = process.env.REACT_APP_CONTRACT_PERIOD_API;
      // POSTのみで保存（Django側で新規or更新を自動判定）
      const response = await axios.post(url, formData, headers);
      return response.data;
    } catch (error) {
      console.error('保存失敗:');
      console.error('ステータス:', error.response.status);
      console.error('エラーメッセージ:', error.response.data.error);
      console.error('トレース:', error.response.data.trace);
      throw error;
    }
};

export default updateContractPeriod;